import { apiClient } from "./client";
import type { PaginatedResponse } from "./types";

export type RouteReview = {
  id: string;
  route_id: string;
  user_id: string;
  route_name: string;
  username: string;
  review_type: string;
  suggested_name: string | null;
  notes: string | null;
  status: string;
  created_at: string;
};

export const moderation = {
  routeReviews: {
    list: (params?: { status?: string; limit?: number; offset?: number }) => {
      const query = new URLSearchParams();
      if (params?.status) query.append("status", params.status);
      if (params?.limit !== undefined) query.append("limit", params.limit.toString());
      if (params?.offset !== undefined) query.append("offset", params.offset.toString());
      return apiClient.request<PaginatedResponse<RouteReview>>(
        `/moderation/route-reviews?${query}`,
        { auth: "mod" },
      );
    },
    approve: (id: string) =>
      apiClient.request<void>(`/moderation/route-reviews/${id}/approve`, {
        auth: "mod",
        method: "POST",
      }),
    delete: (id: string) =>
      apiClient.request<void>(`/moderation/route-reviews/${id}`, { auth: "mod", method: "DELETE" }),
  },
};
